<template>
<div class="site-header" :class="'site-header-'+$teras.app.device">

   <!--mobile -->
   <div class="row yo-text-l pad-in yo-bg-color-primary" style="height:36px;color:#fff;" v-if="$teras.app.device!='desktop'">
      <div class="col s10">EuroMedLab 2019</div>
      <div class="col s2 yo-align-right"><a class="button" v-on:click="$teras.event.emit('sidebarToggle')" style="color:#fff;"><i class="material-icons">menu</i></a></div>
      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>


  <!-- desktop -->
  <div class="row container el-container" v-if="$teras.app.device=='desktop'">
    <div class="col s6 m7 yo-align-left" style="height:210px;overflow:hidden;">
        <img src="../assets/logo.png" style="height:205px;padding:5px 30px 0 0;"/>
    </div>

    <div class="col s6 m5 yo-align-center" style="margin-top:20px;">
      <div class="citta">BARCELONA 2019</div>
      <div class="row pad">
      
      <div class="col s5 data yo-align-right">19-23 MAY</div>
      <div class="col s7 titolo yo-align-left">23<sup>rd</sup> IFCC-EFLM European Congress<br />of Clinical Chemistry and Laboratory Medicine</div>
      </div>
    </div>

  </div>    



   
</div>
</template>

<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
.site-header{
    height: 210px;
    line-height: 36px;
    font-size: 1.8rem;
}.site-header-desktop{
    height: 210px;
    background:#fff;
    width:100vw;
}.header-top {   
    min-height: 36px; 
}.site-header-mobile{
    height: 36px;
    position:fixed;
    left:0;right:0;
    z-index:1001;

}.site-header div.citta{
    color:#F6A015;
    border-bottom:1px solid #F6A015;
    line-height: 36px;
    font-size: 3.4rem;
    text-align:center;
}.site-header div.data{
    line-height: 44px;
    font-size: 2.6rem;
}.site-header div.titolo{
    line-height: 16px;
    font-size: 1.2rem;
}
</style>
